var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c(
        "el-form",
        {
          ref: "loginForm",
          staticClass: "login-form",
          attrs: {
            model: _vm.loginForm,
            rules: _vm.loginRules,
            autocomplete: "on",
            "label-position": "left"
          }
        },
        [
          _c("div", { staticClass: "title-container" }, [
            _c("h3", { staticClass: "title" }, [
              _vm._v("德誠資訊 LineBot系統管理後台")
            ]),
            _c("p", { staticClass: "logo" }),
            _c("h5", { staticClass: "version_title" }, [
              _vm._v(_vm._s(_vm.version))
            ])
          ]),
          _c(
            "el-form-item",
            { attrs: { prop: "partner_id" } },
            [
              _c(
                "span",
                { staticClass: "svg-container" },
                [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                1
              ),
              _c("el-input", {
                ref: "partner_id",
                attrs: {
                  placeholder: "合作夥伴統編(無不需填寫)",
                  name: "partner_id",
                  type: "text"
                },
                model: {
                  value: _vm.loginForm.partner_id,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "partner_id", $$v)
                  },
                  expression: "loginForm.partner_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "username" } },
            [
              _c(
                "span",
                { staticClass: "svg-container" },
                [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                1
              ),
              _c("el-input", {
                ref: "username",
                attrs: {
                  placeholder: "帳號",
                  name: "username",
                  type: "text",
                  tabindex: "1",
                  autocomplete: "on"
                },
                model: {
                  value: _vm.loginForm.username,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "username", $$v)
                  },
                  expression: "loginForm.username"
                }
              })
            ],
            1
          ),
          _c(
            "el-tooltip",
            {
              attrs: {
                content: "Caps lock is On",
                placement: "right",
                manual: ""
              },
              model: {
                value: _vm.capsTooltip,
                callback: function($$v) {
                  _vm.capsTooltip = $$v
                },
                expression: "capsTooltip"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "password" } },
                [
                  _c(
                    "span",
                    { staticClass: "svg-container" },
                    [_c("svg-icon", { attrs: { "icon-class": "password" } })],
                    1
                  ),
                  _c("el-input", {
                    key: _vm.passwordType,
                    ref: "password",
                    attrs: {
                      type: _vm.passwordType,
                      placeholder: "密碼",
                      name: "password",
                      tabindex: "2",
                      autocomplete: "on"
                    },
                    on: {
                      blur: function($event) {
                        _vm.capsTooltip = false
                      }
                    },
                    nativeOn: {
                      keyup: [
                        function($event) {
                          return _vm.checkCapslock.apply(null, arguments)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleLogin.apply(null, arguments)
                        }
                      ]
                    },
                    model: {
                      value: _vm.loginForm.password,
                      callback: function($$v) {
                        _vm.$set(_vm.loginForm, "password", $$v)
                      },
                      expression: "loginForm.password"
                    }
                  }),
                  _c(
                    "span",
                    { staticClass: "show-pwd", on: { click: _vm.showPwd } },
                    [
                      _c("svg-icon", {
                        attrs: {
                          "icon-class":
                            _vm.passwordType === "password" ? "eye" : "eye-open"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "validator" } },
            [
              _c(
                "span",
                { staticClass: "svg-container" },
                [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                1
              ),
              _c("el-input", {
                ref: "validator",
                attrs: {
                  placeholder: "一次性驗證碼(可不須填寫)",
                  name: "一次性驗證碼",
                  type: "text",
                  tabindex: "1",
                  autocomplete: "on"
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleLogin.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.loginForm.validator,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "validator", $$v)
                  },
                  expression: "loginForm.validator"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                position: "relative",
                "text-align": "center",
                padding: "10px auto"
              }
            },
            [
              _c(
                "div",
                { staticClass: "tips" },
                [
                  _c("transition", { attrs: { name: "el-fade-in" } }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.show_otp_message,
                            expression: "show_otp_message"
                          }
                        ],
                        staticClass: "transition-box",
                        staticStyle: { color: "red" }
                      },
                      [
                        _vm._v(
                          "一次性驗證碼將會發送至已綁定合作夥伴line群組或信箱"
                        )
                      ]
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "tips" },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "filter-item",
                      staticStyle: { "margin-left": "15px" },
                      model: {
                        value: _vm.checkbox_remember_me,
                        callback: function($$v) {
                          _vm.checkbox_remember_me = $$v
                        },
                        expression: "checkbox_remember_me"
                      }
                    },
                    [_vm._v(" 記住我 ")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "tips" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loginForm.validator != 9999,
                          expression: "loginForm.validator!=9999"
                        }
                      ],
                      attrs: { type: "primary", loading: _vm.otploading },
                      on: { click: _vm.getOTPvalidator }
                    },
                    [_vm._v("發送OTP驗證碼")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.loading, type: "primary" },
                      nativeOn: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.handleLogin.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("登入")]
                  )
                ],
                1
              )
            ]
          ),
          _c("div", { staticStyle: { position: "relative" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }